import { User } from '@shared/models/user';
import { createAction, props } from '@ngrx/store';

export const loadUser = createAction('[Users] Load User', props<{ userId: string }>());

export const loadUserSuccess = createAction('[Users] Load User Success', props<{ user: User }>());

export const loadUserFailure = createAction('[Users] Load User Failure', props<{ error: any }>());
